import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { MutatePoetryQuizAnswerDTO } from "../../dto";

let body: MutatePoetryQuizAnswerDTO;

export async function modifyPoetryQuizAnswerAction(poetryQuizAnswer: any) {
  const token = localStorage.getItem("token");

  return await axios
    .patch(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/quiz-answers/modify`,
      poetryQuizAnswer,
      {
        headers: {
          "content-type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(MutatePoetryQuizAnswerDTO, res.data);
      await validate(body);
      const errors = await validate(body);
      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
